// 화면과 서버가 같이 쓰는 한도·형식 (docs/architecture.md). 이 폴더는 아무것도 가져오지 않는다
export const NAME_MAX = 10;        // 닉네임 글자 수
export const CHAT_TEXT_MAX = 100;  // 채팅 한 줄 글자 수
export const LOOK_COUNT = 6;       // 외형 종류 수(0 ~ LOOK_COUNT-1) = 주인공 동물 여섯 (js/critters.js CRITTERS 순서)
export const MAX_SPEED = 400;      // pos의 vx·vy 상한(px/s). 걷기 96, 점프 250, 대시 320
export const ROOM_RE = /^[a-z0-9-]{1,32}$/;   // 초대 링크 방 이름 형식
export const TOKEN_RE = /^[A-Za-z0-9_-]{43}$/;   // 사람 토큰: 32바이트 base64url (패딩 없음)
export const FEEDBACK_TEXT_MAX = 1000;     // 피드백 글자 수
export const FEEDBACK_IMG_MAX = 400_000;   // 피드백 사진 data URL 길이
// 자리 번호 상한 MAX_SEAT는 자리 표(shared/world/seats.ts)에서 나온다

// 사진 data URL: 채팅 사진 형식. 서버는 보낸 사진을, 화면은 받은 사진을 이 형식으로 검사한다
const B64 = '[A-Za-z0-9+/]+={0,2}';
export const B64_RE = new RegExp(`^${B64}$`);
export const IMG_RE = new RegExp(`^data:image/(?:jpeg|png|webp);base64,${B64}$`);
